import { computed, watch } from 'vue'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { useRegions } from './useRegions'

export interface RegionOption {
  value: string
  label: string
}

export function useRegionOptions(isoCode: MaybeRefOrGetter<string | undefined>) {
  const { regions, loading, fetchRegions } = useRegions()
  const { locale } = useI18n()

  const options = computed<RegionOption[]>(() =>
    regions.value.map((r) => ({
      value: r._id,
      label: r.region_name,
    }))
  )

  function load() {
    const code = toValue(isoCode)?.trim().toLowerCase()
    if (code) {
      fetchRegions({
        regionIso: code,
        limit: 100,
        locale: locale.value,
      })
    }
  }

  watch(
    [() => toValue(isoCode), locale],
    () => load(),
    { immediate: true }
  )

  return {
    options,
    loading,
    load,
  }
}
